import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/apps/default/index.tsx");
